/** Texts of the projects pages (de), below `projects.projectPages`. */
export const projectPages = {
  fields: {
    number: 'Nummer',
    title: 'Titel',
    type: 'Projektart',
    description: 'Beschreibung',
    client: 'Auftraggeber',
    clientContact: 'Ansprechpartner',
    object: 'Objekt',
    status: 'Status',
    lead: 'Projektleitung',
    period: 'Zeitraum',
    orderedOn: 'Auftragsdatum',
    startsOn: 'Beginn',
    endsOn: 'Geplantes Ende',
    contractEnd: 'Vertragsende',
  },
  list: {
    title: 'Projekte',
    description: 'Projekte der Firma mit Auftraggeber, Objekt und Status.',
    new: 'Neues Projekt',
    objectAndMore_one: '{{name}} und {{count}} weiteres Objekt',
    objectAndMore_other: '{{name}} und {{count}} weitere Objekte',
    search: 'Projekte durchsuchen',
    searchPlaceholder: 'Nummer, Titel, Auftraggeber …',
    allStatuses: 'Alle Status',
    allTypes: 'Alle Projektarten',
    mine: 'Nur meine',
    archive: 'Archiv',
    current: 'Aktuell',
    archived: 'Archiviert',
    period: '{{from}} – {{to}}',
    exportName: 'Projekte',
    empty: 'Noch keine Projekte',
    emptyHint: 'Mit „Neues Projekt“ das erste Projekt anlegen.',
    emptyReadOnly: 'Projekte, in deren Team du stehst, erscheinen hier.',
    noMatches: 'Keine passenden Projekte',
    noMatchesHint: 'Suche oder Filter ändern.',
  },
  form: {
    createTitle: 'Neues Projekt',
    editTitle: 'Projekt bearbeiten',
    more: 'Weitere Angaben',
    chooseType: 'Projektart wählen',
    noTypes: 'Noch keine Projektarten',
    noTypesHint:
      'Ohne Projektart lässt sich kein Projekt anlegen. Bitte die Verwaltung der Projekte fragen.',
    setUpTypes: 'Projektarten einrichten',
    numberHint: 'Die Firma vergibt Projektnummern von Hand.',
    contactHint: 'Zuerst den Auftraggeber wählen.',
    objectHint:
      'Gebäude oder Liegenschaft des Projekts. Weitere Objekte fügst du auf der Projektseite hinzu.',
    created: 'Projekt {{number}} angelegt',
    updated: 'Projekt gespeichert',
    reload: 'Neu laden',
    conflictHint: 'Neu laden zeigt den aktuellen Stand; deine Eingaben gehen dabei verloren.',
  },
  detail: {
    masterData: 'Stammdaten',
    changed: 'geändert {{when}}',
    notFound: 'Projekt nicht gefunden',
    notFoundHint: 'Vielleicht wurde es gelöscht, oder du stehst nicht im Team.',
    archive: 'Archivieren',
    archiveTitle: 'Projekt archivieren?',
    archiveDescription:
      'Projekt {{number}} verschwindet aus Liste und Auswahlfeldern. Unter Archiv bleibt es erhalten und lässt sich zurückholen.',
    archivedToast: 'Projekt archiviert',
    archivedTitle: 'Archiviert',
    archivedSince: 'seit {{when}}',
    restore: 'Zurückholen',
    restored: 'Projekt zurückgeholt',
    deleteTitle: 'Projekt löschen?',
    deleteDescription:
      'Projekt {{number}} wird mit Team, Beteiligten, Leistungen, Dateien und Kommentaren gelöscht. Das lässt sich nicht rückgängig machen.',
    deleted: 'Projekt {{number}} gelöscht',
  },
  team: {
    title: 'Team',
    hint: 'Personen der Firma, die am Projekt arbeiten. Mit Bereich „Team“ sehen nur sie das Projekt.',
    person: 'Person',
    role: 'Rolle',
    roleOf: 'Rolle von {{name}}',
    addMe: 'Mich hinzufügen',
    add: 'Person hinzufügen',
    added: 'Ins Team aufgenommen',
    roleChanged: 'Rolle geändert',
    removeFrom: '{{name}} aus dem Team entfernen',
    removeTitle: 'Aus dem Team entfernen?',
    removeDescription:
      '{{name}} steht danach nicht mehr im Team. Mit Bereich „Team“ ist das Projekt für die Person dann nicht mehr sichtbar.',
    removed: 'Aus dem Team entfernt',
    empty: 'Noch niemand im Team',
    emptyHint: 'Mit „Person hinzufügen“ Kolleginnen und Kollegen ins Team holen.',
    emptyReadOnly: 'Das Team des Projekts erscheint hier.',
  },
  memberRoles: {
    lead: 'Projektleitung',
    deputy: 'Stellvertretung',
    engineer: 'Bearbeitung',
    drafter: 'Zeichnen',
    'site-supervisor': 'Bauleitung',
    assistant: 'Assistenz',
    other: 'Sonstige',
  },
  objects: {
    title: 'Objekte',
    hint: 'Gebäude und Liegenschaften, die das Projekt betreut.',
    count_one: '{{count}} Objekt',
    count_other: '{{count}} Objekte',
    name: 'Objekt',
    city: 'Ort',
    create: 'Neues Objekt',
    add: 'Vorhandenes Objekt zuordnen',
    added: 'Objekt zugeordnet',
    removeFrom: '{{name}} vom Projekt entfernen',
    removeTitle: 'Objekt vom Projekt entfernen?',
    removeDescription:
      '{{name}} gehört danach nicht mehr zum Projekt. Das Objekt selbst bleibt erhalten.',
    removed: 'Objekt entfernt',
    empty: 'Noch kein Objekt',
    emptyHint:
      'Mit „Neues Objekt“ ein Gebäude anlegen oder mit „Vorhandenes Objekt zuordnen“ eines aus früheren Projekten wählen, z. B. alle Schulen eines Schulträgers.',
    emptyReadOnly: 'Die Objekte des Projekts erscheinen hier.',
  },
  participants: {
    title: 'Beteiligte',
    hint: 'Firmen und Stellen außerhalb der Firma, z. B. Architekt, Prüfingenieur, Bauaufsicht.',
    add: 'Beteiligten hinzufügen',
    addTitle: 'Beteiligten hinzufügen',
    editTitle: 'Beteiligten bearbeiten',
    organization: 'Organisation',
    contact: 'Ansprechpartner',
    role: 'Rolle',
    note: 'Notiz',
    actions: 'Aktionen für den Beteiligten',
    added: 'Beteiligten hinzugefügt',
    updated: 'Beteiligten gespeichert',
    removeTitle: 'Beteiligten entfernen?',
    removeDescription:
      'Die Organisation bleibt unter Kunden erhalten, nur der Eintrag am Projekt entfällt.',
    removed: 'Beteiligten entfernt',
    empty: 'Noch keine Beteiligten',
    emptyHint: 'Architekten, Fachplaner oder Behörden mit „Beteiligten hinzufügen“ eintragen.',
    emptyReadOnly: 'Externe Beteiligte des Projekts erscheinen hier.',
  },
  distribution: {
    title: 'Verteiler',
    hint: 'Wer Mails zum Projekt bekommt, z. B. das Baustellenprotokoll. Die Adressen lassen sich auf einmal in die Adresszeile von Outlook kopieren.',
    new: 'Neuer Verteiler',
    newTitle: 'Neuer Verteiler',
    renameTitle: 'Verteiler umbenennen',
    rename: 'Umbenennen',
    created: 'Verteiler angelegt',
    renamed: 'Verteiler umbenannt',
    actions: 'Aktionen für {{name}}',
    count_one: '1 Empfänger',
    count_other: '{{count}} Empfänger',
    empty: 'Noch keine Verteiler',
    emptyHint: 'Mit „Neuer Verteiler“ z. B. einen Verteiler „Protokollempfang“ anlegen.',
    emptyReadOnly: 'Verteiler des Projekts erscheinen hier.',
    notFound: 'Verteiler nicht gefunden. Seite neu laden.',
    fields: {
      listName: 'Name',
      listNameHint: 'Zum Beispiel Protokollempfang oder Rechnungsempfang.',
      name: 'Name',
      email: 'E-Mail-Adresse',
      state: 'Herkunft',
    },
    source: { contact: 'Ansprechpartner', address: 'Eingefügt' },
    missing: {
      unavailable: 'Nicht verfügbar',
      left: 'Ausgeschieden',
      'no-email': 'Ohne Adresse',
    },
    addContact: 'Ansprechpartner hinzufügen',
    paste: 'Aus Outlook einfügen',
    pasteTitle: 'Adressen in „{{name}}“ einfügen',
    pasteLabel: 'Adressen',
    pasteHint:
      'In Outlook die Empfänger in der Adresszeile markieren, kopieren und hier einfügen. Auch einfache Listen mit Semikolon, Komma oder Zeilenumbruch gehen.',
    recognised_one: '1 Adresse erkannt',
    recognised_other: '{{count}} Adressen erkannt',
    invalid_one: '1 Eintrag ist keine gültige Adresse und wird ausgelassen',
    invalid_other: '{{count}} Einträge sind keine gültigen Adressen und werden ausgelassen',
    pasteConfirm_one: '1 Adresse übernehmen',
    pasteConfirm_other: '{{count}} Adressen übernehmen',
    pasted_one: '1 Empfänger aufgenommen',
    pasted_other: '{{count}} Empfänger aufgenommen',
    copy: 'Adressen kopieren',
    copied_one: '1 Adresse kopiert',
    copied_other: '{{count}} Adressen kopiert',
    copiedHint: 'In Outlook in die Zeile An, Cc oder Bcc einfügen.',
    copyFailed: 'Kopieren hat nicht geklappt. Bitte erneut versuchen.',
    skipped_one: '1 Empfänger ohne Adresse wird nicht mitkopiert',
    skipped_other: '{{count}} Empfänger ohne Adresse werden nicht mitkopiert',
    noRecipients: 'Noch keine Empfänger',
    noRecipientsHint: 'Ansprechpartner auswählen oder Adressen aus Outlook einfügen.',
    noRecipientsReadOnly: 'Empfänger des Verteilers erscheinen hier.',
    removeRecipient: '{{name}} aus dem Verteiler entfernen',
    removeTitle: 'Verteiler löschen?',
    removeDescription:
      '„{{name}}“ wird mit allen Empfängern gelöscht. Die Ansprechpartner in Kunden bleiben erhalten.',
    removed: 'Verteiler gelöscht',
  },
  participantRoles: {
    client: 'Bauherr',
    architect: 'Architekt',
    'structural-engineer': 'Tragwerksplanung',
    'specialist-planner': 'Fachplanung',
    'test-engineer': 'Prüfingenieur',
    'building-authority': 'Bauaufsicht',
    'fire-department': 'Feuerwehr',
    contractor: 'Ausführende Firma',
    other: 'Sonstige',
  },
  services: {
    title: 'Leistungen und Phasen',
    add: 'Leistung hinzufügen',
    addTitle: 'Leistung hinzufügen',
    name: 'Leistung',
    nameHint: 'z. B. Brandschutzkonzept oder Objektüberwachung',
    template: 'Phasen aus Vorlage',
    templateHint: 'Die Phasen werden kopiert und lassen sich danach am Projekt ändern.',
    templateOption_one: '{{name}} ({{count}} Phase)',
    templateOption_other: '{{name}} ({{count}} Phasen)',
    noTemplate: 'Ohne Phasen',
    created: 'Leistung angelegt',
    rename: 'Umbenennen',
    renameTitle: 'Leistung umbenennen',
    renamed: 'Leistung umbenannt',
    statusOf: 'Status von {{name}}',
    statusChanged: 'Status der Leistung geändert',
    actionsFor: 'Aktionen für {{name}}',
    phaseCount_one: '{{count}} Phase',
    phaseCount_other: '{{count}} Phasen',
    phasesOf: 'Phasen von {{name}}',
    noPhases: 'Keine Phasen. Über das Menü der Leistung lassen sich Phasen hinzufügen.',
    phaseChanged: '{{name}}: {{status}}',
    doneOn: 'erledigt am {{date}}',
    addPhase: 'Phase hinzufügen',
    phaseCode: 'Kürzel',
    phaseName: 'Bezeichnung',
    phaseCreated: 'Phase hinzugefügt',
    deletePhase: 'Phase {{name}} löschen',
    deletePhaseTitle: 'Phase löschen?',
    deletePhaseDescription: 'Die Phase „{{name}}“ wird aus der Leistung gelöscht.',
    phaseDeleted: 'Phase gelöscht',
    deleteTitle: 'Leistung löschen?',
    deleteDescription: 'Die Leistung „{{name}}“ wird mit allen Phasen gelöscht.',
    deleted: 'Leistung gelöscht',
    empty: 'Noch keine Leistungen',
    emptyHint: 'Mit „Leistung hinzufügen“ ein Leistungsbild mit seinen Phasen anlegen.',
    emptyReadOnly: 'Leistungen und Phasen des Projekts erscheinen hier.',
  },
  serviceStatuses: {
    offered: 'Angeboten',
    ordered: 'Beauftragt',
    active: 'In Arbeit',
    done: 'Erledigt',
    cancelled: 'Entfallen',
  },
  phaseStatuses: {
    'not-ordered': 'Nicht beauftragt',
    ordered: 'Beauftragt',
    active: 'In Arbeit',
    done: 'Erledigt',
  },
  customer: {
    role: 'Rolle',
    client: 'Auftraggeber',
    participant: 'Beteiligt',
    create: 'Projekt anlegen',
    empty: 'Keine Projekte',
    emptyHint:
      'Projekte, bei denen die Organisation Auftraggeber oder beteiligt ist, erscheinen hier.',
  },
  tile: {
    empty: 'Keine laufenden Projekte',
    emptyHint: 'Projekte, in deren Team du stehst, erscheinen hier.',
    more_one: '{{count}} laufendes Projekt',
    more_other: '{{count}} laufende Projekte',
  },
  picker: {
    placeholder: 'Projekt auswählen',
    search: 'Nummer oder Titel suchen',
    empty: 'Kein passendes Projekt',
    create: 'Projekt anlegen',
    createNamed: '„{{title}}“ als Projekt anlegen',
    loading: 'Wird geladen …',
    unavailable: 'nicht verfügbar',
  },
  errors: {
    type: 'Projektart wählen.',
    title: 'Titel eingeben.',
    number: 'Projektnummer eingeben.',
    endsBeforeStart: 'Das Ende liegt vor dem Beginn.',
    organization: 'Organisation auswählen.',
    serviceName: 'Namen der Leistung eingeben.',
    phaseName: 'Bezeichnung der Phase eingeben.',
    invalid: 'Eingabe prüfen.',
    invalidInput: 'Eingaben prüfen.',
    versionConflict: 'Inzwischen von jemand anderem geändert.',
    conflict: 'Passt nicht zum aktuellen Stand. Seite neu laden und erneut versuchen.',
    notFound: 'Projekt nicht gefunden. Vielleicht wurde es gelöscht.',
    memberNotFound: 'Nicht mehr im Team. Seite neu laden.',
    participantNotFound: 'Beteiligten nicht gefunden. Seite neu laden.',
    serviceNotFound: 'Leistung oder Phase nicht gefunden. Seite neu laden.',
    forbidden: 'Dafür fehlt eine Berechtigung.',
    rateLimited: 'Zu viele Anfragen, bitte gleich noch einmal versuchen.',
  },
};
